import def_0 from "./acoustic_selector";
import def_1 from "./attribute_sets";
import def_2 from "./attributes";
import def_3 from "./bim";
import def_4 from "./color_pairing";
import def_5 from "./document_builder";
import def_6 from "./documents";
import def_7 from "./enclosures";
import def_8 from "./fleetwood_blog";
import def_9 from "./forms";
import def_10 from "./helpers/AcousticResultsTable";
import def_11 from "./helpers/AcousticSelectorModal";
import def_12 from "./helpers/ArticleItemList";
import def_13 from "./helpers/BimProductGroupModal";
import def_14 from "./helpers/GenericContentSearch";
import def_15 from "./helpers/PfcItem";
import def_16 from "./helpers/ProductItem";
import def_17 from "./helpers/ProductItemList";
import def_18 from "./helpers/Shingle";
import def_19 from "./helpers/ShingleList";
import def_20 from "./helpers/SwoogoEvents";
import def_21 from "./helpers/acousticSelectorHelpers";
import def_22 from "./helpers/handle_external_url";
import def_23 from "./helpers/item_list_response";
import def_24 from "./helpers/path_to_content";
import def_25 from "./helpers/query_legacy_products";
import def_26 from "./helpers/retrieveImage";
import def_27 from "./insulation_applications_blog";
import def_28 from "./insulation_industrial_blog";
import def_29 from "./insulation_residential_blog";
import def_30 from "./iss";
import def_31 from "./lumber_blog";
import def_32 from "./newsroom_blog";
import def_33 from "./paroc_articles";
import def_34 from "./paroc_structure_selector";
import def_35 from "./products_enclosure";
import def_36 from "./products_fleetwood";
import def_37 from "./products_insulation";
import def_38 from "./products_paroc";
import def_39 from "./products_pfc";
import def_40 from "./products_roofing";
import def_41 from "./reusable";
import def_42 from "./roofing_blog";
import def_43 from "./shingles";
import def_44 from "./swoogo_events";



export default {
  "acoustic_selector": def_0,
  "attribute_sets": def_1,
  "attributes": def_2,
  "bim": def_3,
  "color_pairing": def_4,
  "document_builder": def_5,
  "documents": def_6,
  "enclosures": def_7,
  "fleetwood_blog": def_8,
  "forms": def_9,
  "helpers": {
    "AcousticResultsTable": def_10,
    "AcousticSelectorModal": def_11,
    "ArticleItemList": def_12,
    "BimProductGroupModal": def_13,
    "GenericContentSearch": def_14,
    "PfcItem": def_15,
    "ProductItem": def_16,
    "ProductItemList": def_17,
    "Shingle": def_18,
    "ShingleList": def_19,
    "SwoogoEvents": def_20,
    "acousticSelectorHelpers": def_21,
    "handle_external_url": def_22,
    "item_list_response": def_23,
    "path_to_content": def_24,
    "query_legacy_products": def_25,
    "retrieveImage": def_26
  },
  "insulation_applications_blog": def_27,
  "insulation_industrial_blog": def_28,
  "insulation_residential_blog": def_29,
  "iss": def_30,
  "lumber_blog": def_31,
  "newsroom_blog": def_32,
  "paroc_articles": def_33,
  "paroc_structure_selector": def_34,
  "products_enclosure": def_35,
  "products_fleetwood": def_36,
  "products_insulation": def_37,
  "products_paroc": def_38,
  "products_pfc": def_39,
  "products_roofing": def_40,
  "reusable": def_41,
  "roofing_blog": def_42,
  "shingles": def_43,
  "swoogo_events": def_44
};